module.exports = __webpack_public_path__ + "static/media/pharmacore-slider-new.44777095.jpg";